@import './pk-overlay.variables';

.overlay {
  @apply fixed bottom-0 left-0 top-0 z-[--overlay--zindex] flex h-[--overlay--height] w-[--overlay--width] flex-col opacity-0;
  @apply bg-[color:--overlay--bgcolor];
  @apply translate-y-full transition-[opacity,transform] duration-[--overlay--transition-duration] ease-in-out;

  &.no-animations {
    // If animations are disabled, set opacity to 100% and disable all transitions
    @apply translate-y-0 opacity-100 transition-none;
  }

  &.no-transform {
    // If only transform is disabled, set translate to 0 in the Y axis and enable opacity transition only
    @apply translate-y-0 ease-in-out [transition:opacity_var(--overlay--transition-duration),_z-index_var(--overlay--transition-duration)_0s];
  }

  // Set the z-index to -10 when the overlay is closed and either animations are disabled or transform is disabled
  &.no-animations,
  &.no-transform {
    &:not(.is-open) {
      @apply -z-10;
    }
  }
}

.overlay.from-top:not(.no-animations, .no-transform) {
  // Set translate to -100% in the Y axis when overlay is closed if neither animations or transform are disabled
  @apply -translate-y-full;
}

.overlay.is-open {
  &:not(.no-transform) {
    @apply translate-y-0;
  }

  &:not(.no-animations) {
    @apply opacity-100;
  }
}

.footer {
  @apply pb-[--overlay--padding-bottom] pl-[--overlay--padding-left] pr-[--overlay--padding-right];

  ::slotted(pk-button) {
    @apply w-full #{!important};
  }
}

.content {
  @apply grow overflow-y-auto pb-[--overlay--padding-bottom] pl-[--overlay--padding-left] pr-[--overlay--padding-right] pt-[--overlay--padding-top] font-regular;
}
